import React from 'react';
import User from '../Components/User';
import "./pages.css";
import Breadcrumbs, { IBreadcrumb } from '../Components/Breadcrumbs';

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'Home',
    href: '/',
    className: 'breadcrumb-link',
  },
  {
    name: 'Users',
    href: '',
    isCurrent: true,
    className: 'breadcrumb-current',
  },
];

const AdminUser = () => {
  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="breadcrumb" />
      <User />
    </>
  );
}

export default AdminUser;
